import type { FC } from "react";
import { useState } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { Button } from "@jti/core-components/components/Button";
import type { ContactPersonal } from "@jti/fe-common";

import { SharableLoyaltyProfileDialog } from "./SharableLoyaltyProfileDialog";

type SharableLoyaltyProfileProps = {
  userInfo: ContactPersonal;
  userId: string;
  referralCode: string;
  buttonClassName?: string;
  portalDomNode?: HTMLElement;
  clubCardLogoSrc?: string;
};

export const SharableLoyaltyProfile: FC<SharableLoyaltyProfileProps> = ({
  userInfo,
  userId,
  referralCode,
  buttonClassName,
  portalDomNode,
  clubCardLogoSrc,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { __ } = useTranslations();

  const toggleDialog = () => {
    setIsDialogOpen((prev) => !prev);
  };

  return (
    <>
      <Button
        onClick={toggleDialog}
        variant="primary"
        data-testid="openSharableLoyaltyProfileDialog"
        className={buttonClassName}
      >
        {__("profile.personal_details.sharable_loyalty_profile.button_label")}
      </Button>

      <SharableLoyaltyProfileDialog
        userInfo={userInfo}
        userId={userId}
        referralCode={referralCode}
        isOpened={isDialogOpen}
        onClose={toggleDialog}
        portalDomNode={portalDomNode}
        clubCardLogoSrc={clubCardLogoSrc}
      />
    </>
  );
};
